<template>
  <!-- Old bit.dev component -->
  <div v-if="loading" class="c-base-webpage-loading">
    <div class="c-base-webpage-loading__content">
      <!-- Use this slot to set custom content -->
      <slot>
        <svg
          title="Casar.com"
          desc="ᐅ Casar.com: Eleito o Melhor Site de Casamento do Brasil"
          rel="img"
          class="c-base-webpage-loading__svg"
          width="104px"
          height="116px"
          viewBox="0 0 104 116"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="Home"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="0.0-Home-deslogado_Web"
              transform="translate(-122.000000, -107.000000)"
            >
              <g
                id="logo_responsive"
                transform="translate(122.000000, 107.000000)"
              >
                <g>
                  <g
                    id="Group-22"
                    transform="translate(0.000000, 18.077922)"
                    fill="#F2C574"
                  >
                    <path
                      d="M48.5421683,86.8190525 C28.8860065,85.2899677 12.9346582,69.5566824 11.1320538,49.8876448 C9.5286591,32.4101333 18.9813999,16.9102218 33.2734775,9.59662653 C34.7821262,8.82357574 35.1854043,6.84476019 34.1371242,5.51015363 L31.0335837,1.56346193 C29.9938065,0.242225752 28.1450438,-0.137006712 26.6776946,0.681017161 C9.90642862,10.0342024 -1.1679273,28.4488557 0.0989974781,49.2726076 C1.66595143,75.0312434 22.3072293,95.9437259 48.0028446,97.7839757 C73.0425258,99.575606 94.6786372,83.4120377 101.401963,60.8635075 C101.838038,59.4024901 100.727808,57.9305333 99.2057979,57.9305333 L93.0157225,57.9305333 C91.7585152,57.9305333 90.6264214,58.7120926 90.1988495,59.897194 C84.175187,76.6077322 67.5812661,88.2995177 48.5421683,86.8190525 Z"
                      id="Fill-20"
                    ></path>
                  </g>
                  <g
                    id="Group-25"
                    transform="translate(35.500000, 0.000000)"
                    fill="#E583A2"
                  >
                    <path
                      d="M25.3055209,0.00128844713 L7.64394234,0.00128844713 C6.17332768,-0.0128844713 4.82537183,0.822029269 4.17076109,2.15299516 L0.400616394,9.85275521 C-0.255285492,11.174702 -0.0964746019,12.7659342 0.808618355,13.9294019 L13.4256916,30.1342015 C14.7594449,31.8452593 17.2113301,32.1377368 18.9027306,30.7887326 C19.1415925,30.596754 19.358505,30.3764296 19.5483033,30.1342015 L32.2183136,13.877864 C33.0911279,12.7491844 33.2460654,11.2133554 32.6172775,9.93135048 L28.7787021,2.16330273 C28.1331294,0.837490635 26.8006673,0 25.341673,0 C25.3300526,0 25.3184323,0 25.3055209,0.00128844713 M25.2900271,7.68687558 L22.7903696,2.63745128 L22.7981164,2.63745128 C24.7348346,2.63745128 26.5075773,3.74551581 27.375227,5.50166925 L29.8684289,10.5472282 C27.9304196,10.5472282 26.1576769,9.43916368 25.2900271,7.68687558 M19.3559227,7.68687558 L16.8562651,2.63745128 L16.8627208,2.63745128 C18.8007301,2.63745128 20.5734728,3.74551581 21.4411226,5.50166925 L23.9330333,10.5472282 C21.9963151,10.5472282 20.2261547,9.43916368 19.3559227,7.68687558"
                      id="Fill-23"
                    ></path>
                  </g>
                  <path
                    d="M93.3606631,52.2251082 L98.421758,52.2251082 C100.520438,52.2251082 101.994367,50.1736705 101.345353,48.1815369 C97.2753691,35.6877367 88.5603869,25.2671594 77.2420707,18.9700323 C75.9185677,18.2341774 74.2529677,18.564586 73.3152337,19.7518782 L69.3908229,24.7588385 C68.6714487,25.6774469 68.9807917,27.0172354 70.0264925,27.5352386 C79.3783574,32.1779023 86.8814427,40.3521856 90.48074,50.2111894 C90.9223121,51.4214772 92.0711272,52.2251082 93.3606631,52.2251082"
                    id="Fill-26"
                    fill="#F2C574"
                  ></path>
                  <path
                    d="M104,64.2770563 C104,67.3275533 101.538519,69.8008658 98.5,69.8008658 C95.4626516,69.8008658 93,67.3275533 93,64.2770563 C93,61.2265592 95.4626516,58.7532468 98.5,58.7532468 C101.538519,58.7532468 104,61.2265592 104,64.2770563"
                    id="Fill-28"
                    fill="#E583A2"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
    }
  },

  methods: {
    // method to nuxt loading
    start() {
      this.loading = true
    },
    // method to nuxt loading
    finish() {
      this.loading = false
    },
  },
}
</script>

<style lang="scss">
.c-base-webpage-loading {
  @include position(fixed, 0, 0, 0, 0);
  z-index: 100;
  width: 100%;
  height: 100%;
  padding: 2rem;
  background-color: $white;

  &__content {
    @include position(absolute, 50%, 0, auto, 0, -50%);
    width: 100%;
    text-align: center;
  }

  &__svg {
    width: 60px;
    height: 60px;
  }
}
</style>
